import React from 'react';
import { ChromePicker } from "react-color";

const ColorPicker = ({ color, setPickerChange }) => {
  const sketchPickerStyles = {
    default: {
      picker: {
        position: "absolute",
        top: "0",
        left: "34px",
      },
    },
  };
  return (
    <ChromePicker
      styles={sketchPickerStyles}
      disableAlpha={true}
      color={color}
      onChange={(updatedColor) => setPickerChange(updatedColor.hex)}
    />
  );
};

export default ColorPicker;
